module.exports = __webpack_public_path__ + "img/bureaucrat.6a892d56.png";